import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DateTimePicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffPeikShiftsEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formDescription, setFormDescription] = useState(null);
    const [formBeginning, setFormBeginning] = useState(null);
    const [formEnd, setFormEnd] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-peik-shifts-edit/save-data', {
            id: allProps['taroff-peik-shifts-id'],
            title: formTitle,
            description: formDescription,
            beginning: formBeginning,
            end: formEnd,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-peik-shifts-edit/form-data', {
            id: allProps['taroff-peik-shifts-id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormDescription(response.data.description);
            setFormBeginning(response.data.beginning);
            setFormEnd(response.data.end);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش شیفت های پیک تعارف</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شرح'}
                            value={formDescription}
                            onChange={setFormDescription}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DateTimePicker
                            label={'شروع'}
                            value={formBeginning}
                            onChange={setFormBeginning}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DateTimePicker label={'پایان'} value={formEnd} onChange={setFormEnd} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
